import styled from "styled-components";

export default {
  DivMain: styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 480px;
    height: 100vh;
    background: #ffffff;
    border-left: 1px solid #e5e7eb;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    z-index: 1300;
    display: flex;
    flex-direction: column;
    font-family: "Roboto", sans-serif;

    .div-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 16px;
      border-bottom: 1px solid #f0f0f0;
      position: sticky;
      top: 0;
      background: #ffffff;
      z-index: 10;

      .txt-title {
        font-size: 15px;
        font-weight: 700;
        color: #111827;
        letter-spacing: -0.2px;
      }
    }

    .div-body {
      flex: 1;
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .txt-sectionTitle {
      font-size: 12px;
      font-weight: 700;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      margin-bottom: 8px;
      display: block;
    }

    /* Map container */
    .map-container-wrapper {
      position: relative;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    }

    /* Legend */
    .div-legend {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 12px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .legend-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 600;
        color: #374151;

        .color-line {
          width: 24px;
          height: 4px;
          border-radius: 2px;
        }

        &.passenger .color-line {
          background: #3b82f6;
        }

        &.driver .color-line {
          background: #f97316;
        }
      }
    }

    /* Trip summary card */
    .div-tripCard {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .lbl-key {
          font-size: 12px;
          color: #6b7280;
        }
        .lbl-val {
          font-size: 12px;
          font-weight: 600;
          color: #111827;
        }
      }
    }

    /* Loading/Error */
    .div-loading, .div-error, .div-noData {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      gap: 8px;
      text-align: center;

      .txt-loading { font-size: 13px; color: #9ca3af; }
      .txt-error { font-size: 13px; color: #ef4444; }
      .txt-noData { font-size: 13px; color: #6b7280; font-weight: 500; }
    }
  `,
};
